import React, { useState } from "react";
import db from "../../db/index.json";
import ParagraphTag from "../reusebale/Paragraph";
import {
  UserRound,
  Hourglass,
  Mail,
  CalendarDays,
  Calendar,
} from "lucide-react";
import { useSelector } from "react-redux"
const StaffInfo = ({ onBack }) => {
  const { support } = db;

  const { loader, loginSuccess, loginError } = useSelector(
    (state) => state.auth
  );


  function GetSelectedDays(schedule) {
    return schedule
      .filter(item => item.isSelected) // Filter selected days
      .map(item => item.day) // Extract the 'day' value
      .join(", "); // Combine into a single string
  }
  return (
    <div className="bg-white rounded-xl mt-6">
      <div className="flex mt-1 items-center py-14">
        {/* <div className="w-[30%] flex justify-center">
          <ImageTag
            path="/assets/daashboard/company-info-Round.png"
            classes="w-[135px] rounded-full"
            altText="logo"
          />
        </div> */}
        <div className="w-full pl-8">
          <div className="w-[80%]">
            <div>
              <ParagraphTag
                content="Personal Info"
                classes="text-darkColor font-popinsSemiBold text-lg"
              />
            </div>
            <div className="pt-4 flex w-full">
              <div className="w-[33%] flex items-end">
                <div className="w-9 h-9 rounded-full flex justify-center items-center bg-bgColor">
                  <UserRound color="#FF814E" strokeWidth={2} size={20} />
                </div>
                <div className="pl-2">
                  <ParagraphTag
                    content="First Name"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={loginSuccess?.user?.firstName}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
              <div className="w-[33%] flex items-center">
                <div className="w-9 h-9 rounded-full flex justify-center items-center bg-bgColor">
                  <UserRound color="#FF814E" strokeWidth={2} size={20} />
                </div>
                <div className="pl-2">
                  <ParagraphTag
                    content="Last Name"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={loginSuccess?.user?.lastName}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
              <div className="w-[33%] flex items-center">
                <div className="w-9 h-9 rounded-full flex justify-center items-center bg-bgColor">
                  <Hourglass color="#FF814E" strokeWidth={2} size={20} />
                </div>
                <div className="pl-2">
                  <ParagraphTag
                    content="Shift hours"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={`${loginSuccess?.user?.shiftHours} hours`}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
            </div>
            <div className="pt-7 flex">
              <div className="w-[33%] flex items-center">
                <div className="w-9 h-9 rounded-full flex justify-center items-center bg-bgColor">
                  <Mail color="#FF814E" strokeWidth={2} size={20} />
                </div>
                <div className="pl-2">
                  <ParagraphTag
                    content="Email Address"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={loginSuccess?.user?.email}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
              <div className="w-[33%] flex items-center">
                <div className="w-9 h-9 rounded-full flex justify-center items-center bg-bgColor">
                  <Calendar color="#FF814E" strokeWidth={2} size={20} />
                </div>
                <div className="pl-2">
                  <ParagraphTag
                    content="Type"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={loginSuccess?.user?.type}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
              <div className="w-[33%] flex items-center">
                <div className="w-9 h-9 rounded-full flex justify-center items-center bg-bgColor">
                  <CalendarDays color="#FF814E" strokeWidth={2} size={20} />
                </div>
                <div className="pl-2">
                  <ParagraphTag
                    content="Days in a week"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={loginSuccess?.user?.shiftDays ? GetSelectedDays(loginSuccess?.user?.shiftDays) : ""}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffInfo;
